import { Component, Input, ViewChild, inject, input } from '@angular/core';
import { SettingsService } from '../../../shared/settings/settings.service';
import { PdfEditorType } from '../../../shared/enums/pdf-editor-type';
import { LDWDocument } from '../../../shared/models/LDWDocument';
import { RouterStateSnapshot } from '@angular/router';
import { PdftEditorComponent } from '../../../pdf-pdft/pdft-editor/pdft-editor.component';
import { Observable, of } from 'rxjs';
import { PlanningJob } from '../../../shared/models/planning-job';

@Component({
  selector: 'ldw-document-view',
  templateUrl: './document-view.component.html',
  styleUrls: ['./document-view.component.css'],
  standalone: false
})
export class DocumentViewComponent {
  private _settingsService = inject(SettingsService);

  @Input() document: LDWDocument | undefined = undefined;
  @Input() readOnly = false;
  @Input() isDetail = false;
  @Input() search = '';
  @Input() pageNumber = 1;
  @Input() pageZoom = 1;
  @Input() doCloseNotNavigate = false;
  selectedPlanningJob = input<PlanningJob>()
  @ViewChild('pdftEditor') pdftEditor!: PdftEditorComponent;

  public isPdfViewer(): boolean {
    return this._settingsService.settings.pdfSettings.currentEditor().type == PdfEditorType.Viewer;
  }

  public isPdftEditor(): boolean {
    return this._settingsService.settings.pdfSettings.currentEditor().type == PdfEditorType.Editor;
  }

  public isReadOnly(): boolean {
    return this.readOnly;
  }

  public downloadAllowed(): boolean {
    return !this._settingsService.settings.pdfSettings.disableDownload;
  }

  public printingAllowed(): boolean {
    return !this._settingsService.settings.pdfSettings.disablePrinting;
  }

  /**
    returns true close is allowed
   */
  public checkCanClose(): Observable<boolean> {
    if (this.isPdftEditor()) {
      return this.pdftEditor.checkCanClose();
    }
    return of(true);
  }

  public checkCanCloseNavigate(nextState: RouterStateSnapshot | undefined): Observable<boolean> {
    if (this.isPdftEditor()) {
      // if we are in edit mode, default routing is denied
      // therefore we have to provide the new route, if the user selects to discard changes or save
      return this.pdftEditor.checkCanClose();
    }
    return of(true);
  }
}
